import * as React from "react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "../ui/tooltip";
import { buildActionItemActions } from "./action-item.utils";
import { ICompasAIChatAction } from "@/types/compass.types";

interface ActionItemActionsProps {
  action: ICompasAIChatAction;
  isExpanded: boolean;
  toggleExpansion: () => void;
  handleToggleEditing: () => void;
  handleDeleteAction: () => void;
  handleSaveToLibrary: () => void;
  currentStatus: string;
}

export const ActionItemActions: React.FC<ActionItemActionsProps> = (props) => {
  const actions = buildActionItemActions(props);

  return (
    <div className="flex flex-col items-center gap-3">
      {actions.map((act) => (
        <TooltipProvider key={act.id}>
          <Tooltip>
            <TooltipTrigger asChild>
              <div
                onClick={(e) => {
                  if (act.disabled) {
                    e.stopPropagation();
                    return;
                  }
                  act.onClick(e);
                }}
                className={act.disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"}
              >
                {act.icon}
              </div>
            </TooltipTrigger>
            <TooltipContent>
              <p>{act.tooltipContent}</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      ))}
    </div>
  );
};
